import { Component, OnInit } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-anim-edc',
  templateUrl: './anim-edc.component.html',
  styleUrls: ['./anim-edc.component.scss']
})
export class AnimEdcComponent implements OnInit {
  tlCloud1 = gsap.timeline( { repeat:-1, yoyo:true} );
  tlCloud2 = gsap.timeline( { repeat:-1, yoyo:true} );
  tlWifi = gsap.timeline( { repeat:-1, yoyo:true} );
  tlRoad = gsap.timeline( { repeat:-1, yoyo:true} );
  tlWave = gsap.timeline( { repeat:-1 } );
  tlCpu = gsap.timeline( { repeat:-1, yoyo:true} );

  constructor() { }

  ngOnInit(): void {
    this.animateCloud();
    this.animateWifi();
    this.animateRoad();
    this.animateWave();
    this.animateCpu();

  }
  
  ngOnDestroy(): void{
    this.tlCloud1.kill();
    this.tlCloud2.kill();
    this.tlWifi.kill();
    this.tlRoad.kill();
    this.tlWave.kill();
    this.tlCpu.kill();
  }

  animateCloud() {
    // var tl = gsap.timeline( { repeat:-1, yoyo:true} );
    this.tlCloud1.fromTo( '#cloud1', {x: 0, y: 0}, {x: -60, y: 50, duration: 2, ease: "power0"})
    // var tl2 = gsap.timeline( { repeat:-1, yoyo:true} );
    this.tlCloud2.fromTo( '#cloud2', {x: 0, y: 0}, {x: 60, y: -50, duration: 2, ease: "power0"})
  }

  animateWifi() {
    // var tl = gsap.timeline( { repeat:-1, yoyo:true} );
    // tl.set('#wifi1, #wifi2, #wifi3, #wifi4', { 
    //   visibility:'hidden', 
    // })
    this.tlWifi.fromTo( '#wifi1, #wifi2, #wifi3, #wifi4', {x: 0, y: 0}, {x: 0, y: -20, duration: 2, ease: "power0"})
  }

  animateWave() {
    // var tl = gsap.timeline( { repeat:-1 } );
    this.tlWave.set('.first-wave', { visibility:'hidden', strokeDashoffset: '-150' })
    .set('.second-wave', { visibility:'hidden', strokeDashoffset: '-230' })
    .set('.third-wave', { visibility:'hidden', strokeDashoffset: '160' })
    .set('.fourth-wave', { visibility:'hidden', strokeDashoffset: '270' })

    .to( '.first-wave', { 
      visibility:'visible', 
      strokeDashoffset: '150',
      duration:0.7,
    }).to( '.second-wave', { 
      visibility:'visible', 
      strokeDashoffset: '230',
      duration:0.7,
      onEnter: () => {
        this.tlWave.to( '.third-wave', { 
            visibility:'visible', 
            strokeDashoffset: '-160',
            duration:0.7,
          }, '<+0.2')
          .to( '.fourth-wave', { 
            visibility:'visible', 
            strokeDashoffset: '-270',
            duration:0.7,
          }, '<+0.1')
      },
    })
  }
  
  animateRoad() {
    // var tl = gsap.timeline( { repeat:-1, yoyo:true} );
    this.tlRoad.fromTo( '#road', {x: 0, y: 0, opacity: 1}, {x: -1, y: 1, duration: 0.5, ease: "power0", opacity: 0.5});
  }

  animateCpu() {
    // var tl = gsap.timeline( { repeat:-1, yoyo:true} );
    this.tlCpu.fromTo( '#cpu', {opacity: 1}, {duration: 0.3, ease: "power0", opacity: 0.2})
      .to( '#cpu', {opacity: 1, duration:0.8})
  }
}
